<template>
  <div class="wrapper">
    <a href="javascript:void(0);" @click="onClick">
      {{ params.data.title }}
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    onClick: function () {
      this.params.context.componentParent.setProjectData(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
